import React, { useState } from "react";
import MainCalculatorsList from "../OtherCalculator/CountriesMainCalculatorsList/SAMainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "حاسبة الأوفر تايم - حساب أجر الساعات الإضافية في السعودية";
const DESCRIPTION =
  "استخدم حاسبة الأوفر تايم لحساب قيمة أجر الساعات الإضافية بناءً على الراتب الأساسي والإجمالي وعدد ساعات العمل الإضافي في السعودية.";
const KEYWORDS =
  "حاسبة الأوفر تايم, حساب ساعات العمل الإضافي, أجر الساعات الإضافية, راتب, أجر, السعودية, الراتب الأساسي, الراتب الإجمالي, الساعات الإضافية";
const OG_URL =
  "https://do-calculate.com/calculator/ar/countries/SA/calculators-list/overtime-calculator/";
function OvertimeCalculator() {
  const [basicSalary, setBasicSalary] = useState("");
  const [totalSalary, setTotalSalary] = useState("");
  const [overtimeHours, setOvertimeHours] = useState("");
  const [overtimePay, setOvertimePay] = useState(null);
  const [error, setError] = useState("");
  const calculateOvertimePay = () => {
    try {
      const hourlyRate = (totalSalary * 1.5) / 240;
      const totalOvertimePay = hourlyRate * Number(overtimeHours);
      setOvertimePay({
        hourlyRate: hourlyRate.toFixed(2),
        totalOvertimePay: totalOvertimePay.toFixed(2),
      });
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  مرحبًا بك في حاسبة الأوفر تايم المصممة خصيصًا لحساب أجر الساعات الإضافية في المملكة العربية السعودية.
                  تتيح لك هذه الأداة السهلة الاستخدام حساب قيمة الساعات الإضافية بناءً على الراتب الأساسي والإجمالي،
                  وذلك وفقًا لأنظمة العمل في السعودية. سواء كنت موظفًا بدوام كامل أو جزئي، فإن هذه الحاسبة تساعدك على
                  معرفة حقوقك المالية بدقة وسهولة.
                </p>
                <p>
                  قم بإدخال راتبك الأساسي وعدد الساعات الإضافية التي عملت بها لتحصل فورًا على قيمة الأجر المستحق
                  للساعات الإضافية. نأخذ بعين الاعتبار قوانين العمل السعودية التي تحدد أجر الساعات الإضافية
                  بنسبة معينة من الراتب الأساسي.
                </p>
                <p>
                  ابدأ الآن باستخدام حاسبة الأوفر تايم لضمان احتساب أجر ساعاتك الإضافية بشكل دقيق وسريع.
                  هذه الأداة مفيدة لكل موظف يرغب في التأكد من حصوله على كامل مستحقاته وفقًا للقانون.
                </p>
                <hr />
              </div>
            </div>
             <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div className="bg-warning text-black text-center p-2">
                  <u>
                    <b>ملاحظة هامة</b>:
                  </u>{" "}
                  <p>
                    هذه الحاسبة مخصصة للعاملين في المملكة العربية السعودية فقط.
                  </p>
                </div>
                <div className="p-3">
                                    <div className="form-group">
                    <label>الراتب الأساسي:</label>
                    <input
                      type="number"
                      value={basicSalary}
                      onChange={(e) => setBasicSalary(e.target.value)}
                      className="form-control mb-2"
                      placeholder="أدخل الراتب الأساسي"
                    />
                  </div>
                                    <div className="form-group">
                    <label>الراتب الإجمالي (الأساسي + البدلات):</label>
                    <input
                      type="number"
                      value={totalSalary}
                      onChange={(e) => setTotalSalary(e.target.value)}
                      className="form-control mb-2"
                      placeholder="أدخل الراتب الإجمالي"
                    />
                  </div>
                                    <div className="form-group">
                    <label>عدد الساعات الإضافية:</label>
                    <input
                      type="number"
                      value={overtimeHours}
                      onChange={(e) => setOvertimeHours(e.target.value)}
                      className="form-control mb-2"
                      placeholder="أدخل عدد الساعات الإضافية"
                    />
                  </div>
                  <br />
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px", marginLeft: "10px" }}
                    onClick={calculateOvertimePay}
                  >
                    احسب                  </button>
                </div>
                { error !== "" ? (
                  <p className="p-3 mb-2 bg-warning text-white">خطأ: {error}</p>
                ) : (
                  overtimePay !== null && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <p>
                        أجرة ساعة العمل الإضافي الواحدة:{" "}
                        {overtimePay.hourlyRate} ريال
                      </p>
                      <p>
                        أجرة {overtimeHours} ساعة عمل إضافي:{" "}
                        {overtimePay.totalOvertimePay} ريال
                      </p>
                    </div>
                  )
                )}
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                كيفية حساب قيمة ساعات العمل الإضافي
              </div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      الخطوة 1: حساب أجرة ساعة العمل
                    </h2>
                  </u>
                  <p>
                    يتم حساب أجرة الساعة بناءً على الراتب الإجمالي بتقسيم الراتب
                    الإجمالي على 240 (8 ساعات * 30 يوم).
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      الخطوة 2: حساب قيمة ساعة العمل الإضافي
                    </h2>
                  </u>
                  <p>
                    يتم حساب قيمة ساعة العمل الإضافي بضرب أجرة الساعة في نسبة
                    الأجر الإضافي (1.5).
                  </p>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      الخطوة 3: حساب إجمالي أجر الساعات الإضافية
                    </h2>
                  </u>
                  <p>
                    يتم حساب إجمالي أجر الساعات الإضافية بضرب عدد الساعات
                    الإضافية في قيمة ساعة العمل الإضافي.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black ">
                    مثال: إذا كان أجر الساعة 35.42 ريالاً، وعدد الساعات الإضافية
                    10 ساعات، فإن قيمة ساعات العمل الإضافي = 35.42 * 10.
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      الخطوة 4: جمع الأجر الإجمالي
                    </h2>
                  </u>
                  <p>
                    جمع الراتب الأساسي مع الأجر الناتج عن الساعات الإضافية
                    للحصول على الأجر الإجمالي.
                  </p>
                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default OvertimeCalculator;
